import React from 'react';
import { APP_TERMS } from '../../../app-terms';
import { Checkbox, Col, Form, Row } from 'antd';
import PropTypes from 'prop-types';
import TextEditor from '../../../components/TextEditor';
import { CASE_FORM_TYPES, STUDY_PURPOSES } from '../../../appContants';

const StudyPurpose = ({ form }) => {
  return (
    <Form
      name={CASE_FORM_TYPES.studyPurpose}
      form={form}
      layout="vertical"
      autoComplete="off"
    >
      <Row gutter={16} className="mt-3">
        <Col>
          <h4>{`${APP_TERMS.generic_study} ${APP_TERMS.generic_purpose}`}</h4>
        </Col>
      </Row>
      <Row gutter={16}>
        {STUDY_PURPOSES.map((purpose) => (
          <Col xs={24} sm={12} md={8} key={purpose.fieldName}>
            <Form.Item
              name={purpose.fieldName}
              valuePropName="checked"
              initialValue={false}
            >
              <Checkbox>{purpose.label}</Checkbox>
            </Form.Item>
          </Col>
        ))}
      </Row>
      <Row gutter={16}>
        <Col span={24}>
          <Form.Item
            name="doctorsNotes"
            label={APP_TERMS.region_interest_cases_comments_label}
          >
            <TextEditor />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

StudyPurpose.propTypes = {
  form: PropTypes.any,
};
export default StudyPurpose;
